import cx from "classnames";
import { JSX, useEffect, useRef } from "react";

export interface WizardNavigationBarProps {
  /**
   * Declares whether the nav bar is inside a flyout.
   * position: sticky doesn't generally work in our flyouts, so this makes the necessary adjustments.
   */
  isInAFlyout?: boolean;

  /**
   * The content that goes on the left side of the navigation banner
   */
  leftSide?: JSX.Element;

  /**
   * The content that goes on the right side of the navigation banner
   */
  rightSide: JSX.Element;
}

export const WizardNavigationBar = (props: WizardNavigationBarProps): JSX.Element => {
  const divRef = useRef(null);

  useEffect(() => {
    // detects when the element is "stuck" due to position sticky's condition,
    // and adds a new class in those cases. This allows for different styling when stuck.
    // The observer declaration also has to be outside the conditional to allow the 
    // disconnect in the unmount/return function
    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle("is-stuck", e.intersectionRatio < 1),
      { threshold: [1] }
    );
    if (divRef.current) {
      observer.observe(divRef.current);
    }

    return () => {
      observer.disconnect();
    }
  }, [divRef.current]);

  return (
    <div
      className={cx({
        "in-a-flyout": props.isInAFlyout,
        "wizard-navigation-bar": true,
      })}
      ref={divRef}
    >
      {props.leftSide}
      {props.leftSide ? props.rightSide : <div className="only-right-side">{props.rightSide}</div>}
    </div>
  );
};
